import { BaseMessage } from '@langchain/core/messages';
import { Result } from 'bloggers-backend/lib/domain/Result';

export function contentText(message: BaseMessage): string {
  const { content } = message;
  if (typeof content === 'string') {
    return content;
  }
  if (!Array.isArray(content)) {
    return '';
  }
  return content
    .map((block) => {
      if (typeof block === 'string') {
        return block;
      }
      if (block && block.type === 'text' && typeof block.text === 'string') {
        return block.text;
      }
      return '';
    })
    .filter(Boolean)
    .join('\n');
}

export function isToolRejection(content: string): boolean {
  return /^User rejected the tool call/.test(content);
}

export function parseToolResult(content: string): Result<unknown> {
  try {
    return JSON.parse(content) as Result<unknown>;
  } catch {
    return { success: true, value: content };
  }
}
